const ID_KEY = 'cbp.player.v1'

function safeId(value) {
  return String(value || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 80)
}

export function playerId(session) {
  const fromAccount = safeId(session?.providerSub ? `u${session.providerSub}` : '')
  if (fromAccount.length >= 8) return fromAccount
  if (typeof localStorage === 'undefined') return 'localplayer'
  let id = safeId(localStorage.getItem(ID_KEY))
  if (id.length < 8) {
    const uuid = globalThis.crypto?.randomUUID?.() || `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`
    id = safeId(`p${uuid}`)
    localStorage.setItem(ID_KEY, id)
  }
  return id
}

export function displayName(session) {
  const name = String(session?.name || '').replace(/\s+/g, ' ').trim()
  if (!name || name.includes('@')) return 'Tú'
  return name.slice(0, 24)
}

export async function fetchRank(session) {
  const id = playerId(session)
  const res = await fetch(`/api/ranking?id=${encodeURIComponent(id)}`)
  if (!res.ok) throw new Error('ranking')
  return res.json()
}

export async function publishScore(session, bp) {
  const res = await fetch('/api/ranking', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: playerId(session),
      name: displayName(session),
      bp: Math.max(0, Math.round(Number(bp) || 0)),
    }),
  })
  if (!res.ok) throw new Error('ranking')
  return res.json()
}
